/**
 * Common program and game section
 */
import '../../../resource/styles/item.scss';
import "./SubModal.js";

class Item {
	constructor(data, type, isGrid, customGrid)
	{
		this.type = type;
		this.isGrid = isGrid;
		this.data = data;
		this.customGrid = customGrid;
	}

	processData(item)
	{
		let isSubscriber = window.client && window.client.user && window.client.user.isSubscriber;
		let defaultImage = config.LOC_RESOURCE+ 'espnplayer/site_4/images/default_video.jpg';
		item.itemName = item.name ? item.name : '';
		if(this.type == 'program')
		{
			item.itemClass = 'program-section program-section-' + item.id;
			item.itemGrouping = item.showTitle ? item.showTitle : '';
			item.itemSrc = item.image ? config.LOC_CONTENT + item.image : defaultImage;
			item.itemRuntime = item.runtimeHours.indexOf(":") == -1 ? Number(item.runtimeHours) : this.timeToSeconds(item.runtimeHours);
			if(item.position != null && item.position != 0)
			{
				let progress = 0;
				if (item.position > 0 && item.itemRuntime > 0)
				{
					progress = 100 * item.position / item.itemRuntime;
				}
				item.itemProgress = `<div class="progress" style="width: ${progress}%"></div>`;
			}
			if(isSubscriber || item.purchaseTypeId == null)
			{
				item.itemAuth = config.LOC_SERVER + 'video/' + item.seoName;
			}
			else
			{
				item.itemAuth = "javascript:showSubModal.showModal();";
			}
			if(item.liveState == 0)
			{
				item.itemStatus = 'upcoming';
				item.itemDate = NEU.formatDate(item.beginDateTime, NEU.getLocalizedString("full_date_format"));
			}
			else if(item.liveState == 1 || item.liveState == 2)
			{
				item.itemStatus = 'live';
				item.itemDate = NEU.getLocalizedString("time_on_now");
			}
			else
			{
				item.itemStatus = 'vod';
				item.itemDate = item.runtimeHours;
			}
		}
		else
		{
			item.itemClass = 'game-section game-section-' + item.id;
			item.itemGrouping = item.grouping ? item.grouping : '';
			item.itemSrc = item.image ? config.LOC_CONTENT + 'games/' + item.image : defaultImage;
			if(isSubscriber || item.free == 1 || (client.isLoggedIn == true && item.free == 0))
			{
				item.itemAuth = config.LOC_SERVER + 'game/' + item.seoName;
			}
			else if(client.isLoggedIn == false && item.free == 0)
			{
				item.itemAuth = "javascript:showSignIn();"
			}
			else
			{
				item.itemAuth = "javascript:showSubModal.showModal();";
			}
			if(item.tbd && item.tbd == 0)
			{
				item.itemDate = NEU.getLocalizedString("game_if_necessary");
			}
			else if(item.tbd && item.tbd == 1)
			{
				item.itemDate = NEU.getLocalizedString("game_tbd");
			}
			else if(item.tbd && item.tbd == 2)
			{
				item.itemDate = NEU.getLocalizedString("game_postpond");
			}
			else
			{
				let itemDate = "";
				let beginDateTimeGmt = item.beginDateTimeGMT || item.dateTimeGMT;
				if(new Date(beginDateTimeGmt + "Z").toLocaleDateString() == new Date().toLocaleDateString())
				{
					itemDate = NEU.formatDateToLocalDate(beginDateTimeGmt, NEU.getLocalizedString("today_date_format"));
				}
				else
				{
					itemDate = NEU.formatDateToLocalDate(beginDateTimeGmt, NEU.getLocalizedString("full_date_format"));
				}
				if(item.gameState == 0)
				{
					item.itemStatus = 'upcoming';
					item.itemDate = itemDate;
				}
				else if(item.gameState == 1)
				{
					item.itemStatus = 'live';
					item.itemDate = NEU.getLocalizedString("time_on_now");
				}
				else if(item.gameState == 2 || item.gameState == 3)
				{
					item.itemStatus = 'vod';
					item.itemDate = itemDate
				}
				else
				{
					item.itemStatus = 'unavailable';
					item.itemDate = '';
				}
			}
		}
	}

	processDom(item)
	{
		let str = `<div class="common-item ${item.itemClass} status-${item.itemStatus} ${!!this.isGrid ? (!!this.customGrid ? this.customGrid : 'col-md-3 col-sm-4 col-xs-12') : ''}" data-id="${item.id}" ${this.type == 'program' ? `data-runtime=${item.itemRuntime}` : ``}>
								<div class="detail">
									<a href="${item.itemAuth}" data-link-name="${item.itemName}">
										<img  class="img img-responsive" src="${item.itemSrc}" alt="${item.itemName}" onerror="commonItemImageError(event,'${item.type ? item.type :"video"}')" />
										<div class="bg"></div>
										${ item.itemDate !=='' ? '<div class="state">' + item.itemDate + '</div>':''}
									</a>
									<div data-toggle="history">${item.itemProgress ? item.itemProgress : ''}</div>
								</div>
								<div class="info">
									<p class="title" title="${item.itemName}">
										<a href="${item.itemAuth}">${item.itemName}</a>
									</p>
									<p class="grouping" title="${item.itemGrouping}">${item.itemGrouping}</p>
								</div>
							</div>`;
		return str;
	}

	timeToSeconds(time)
	{
		let h = 0, m = 0, s = 0, seconds = 0;
		let length = 0;
		if(time.indexOf(":") != -1)
		{
			length = time.split(":").length - 1;
			if(length == 1)
			{
				m = Number(time.split(":")[0]);
				s = Number(time.split(":")[1]);
				seconds = m * 60 + s;
			}
			else if(length == 2)
			{
				h = Number(time.split(":")[0]);
				m = Number(time.split(":")[1]);
				s = Number(time.split(":")[2]);
				seconds = h * 3600 + m * 60 + s;
			}
		}
		return seconds;
	}

	getDom()
	{
		let str = `<div class="common-section${!!this.isGrid ? ' grid' : ' owl-carousel'}">`;
		for(let i=0; i<this.data.length; i++)
		{
			this.processData(this.data[i]);
			str += this.processDom(this.data[i]);
		}
		str += `</div>`;
		return str;
	}
}

export default Item;
